var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.ScanGift,{attrs:{"campaignId":_setup.campaignId,"spId":_setup.spId},on:{"showState":_setup.handleShowState}},[_c(_setup.NewUserSmallBar,{attrs:{"slot":"header"},slot:"header"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }